module.exports = __webpack_public_path__ + "static/media/redCheck.75ff0581.svg";